import { proxy } from 'valtio';
import { deepClone } from 'valtio/utils';

type ValidationState = {
    activeZone: string | null;
    activeComponentInstance: string | null;
};

const validationStateDefaults: ValidationState = {
    activeZone: null,
    activeComponentInstance: null,
};

const validationState = proxy(deepClone(validationStateDefaults));

export { validationState, validationStateDefaults };
